/* eslint-disable eslint(jsx-a11y/no-static-element-interactions) */
import React from 'react'
import posed from 'react-pose'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import STYLE_CONSTANTS from '~/style/constants'

const Container = styled.div`
  display: flex;
  flex-direction: row;
  min-width: ${props => (props.isMobile ? '100px' : '140px')};
  height: 60px;
  padding: 17px;
  font-family: ${props => props.theme.fonts.avenirNextMedium};
  font-size: 1.125rem;
  ${props => (props.flip ? 'justify-content: flex-end;' : null)}
`

const TextBase = styled.div`
  cursor: pointer;
  user-select: none;
`

const Text = posed(TextBase)({
  init: {
    color: STYLE_CONSTANTS.colors.text.darkGray,
    scale: 1
  },
  hoverable: true,
  hover: {
    color: STYLE_CONSTANTS.colors.primary.blue,
    scale: 1
  },
  pressable: true,
  press: {
    color: STYLE_CONSTANTS.colors.primary.blue,
    scale: 0.95
  }
})

const Image = styled.img`
  ${props => (props.position === 'right' ? 'margin-left: 16px;' : null)}
  ${props => (props.position === 'left' ? 'margin-right: 16px;' : null)}
`

const PlainTextButton = ({ onClick, text, image, position, isMobile }) => {
  const imgProps = {
    position,
    src: image
  }
  return (
    <Container isMobile={isMobile}>
      {image && position === 'left' ? <Image {...imgProps} /> : null}
      <Text onClick={onClick}>{text}</Text>
      {image && position === 'right' ? <Image {...imgProps} /> : null}
    </Container>
  )
}

PlainTextButton.defaultProps = {
  position: 'right',
  image: null
}

PlainTextButton.propTypes = {
  position: PropTypes.oneOf(['left', 'right']),
  onClick: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  image: PropTypes.string
}

export default PlainTextButton
